export const ICON_SPRITE = "/icons-generated/_icon-sprite.svg";
